"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var makeObjectStoreProxy = exports.makeObjectStoreProxy = function makeObjectStoreProxy(target) {
  return new Proxy(target, {
    get: function get(target, name) {
      return target[name] || target.storeService[name];
    },
    set: function set(target, prop, value) {
      target.apiService[prop] = value;
      target.storeService[prop] = value;
      return true;
    }
  });
};